import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    save: false
  },
  getters: {
  },
  mutations: {
    login (state) {
      localStorage.setItem('token', 'spoiujhbvcftgzu1234kjihjb654gGHc')
      state.token = 'spoiujhbvcftgzu1234kjihjb654gGHc'
    },
    isSave (state, val) {
      if (val) {
        state.save = true
      } else if (!val) {
        state.save = false
      }
    }
  },
  actions: {
  },
  modules: {
  }
})
